<p-dialog [baseZIndex]="1000" [modal]="true" [(visible)]="displayModal" (onHide)="closeDialog()"
  [contentStyle]="{'overflow':'visible'}" class="password-scaduta-dialog" header="{{'passwordScaduta' | translate}}">
  <div class="row" *ngIf="formPassword">
    <div class="col-12">
      <form>
        <form-row>
          <ng-template formRowTemplate="content">
            <form-input-password [control]="formPassword.controls['newPassword']" [label]="'nuovaPassword'|translate"
              [placeholder]="'stdPlaceholder'|translate" [errorMsg]="'newPasswordError_msg'|translate">
            </form-input-password>
          </ng-template>
        </form-row>

        <form-row>
          <ng-template formRowTemplate="content">
            <form-input-password [control]="formPassword.controls['newPasswordConfirm']" [label]="'confermaNuovaPassword'|translate"
              [placeholder]="'stdPlaceholder'|translate" [errorMsg]="'newPasswordConfirmError_msg'|translate">
            </form-input-password>
          </ng-template>
        </form-row>

        <hr>

        <form-row>
          <ng-template formRowTemplate="content">
            <div class="buttonbar">
              <button type="button" class="btn btn-danger text-white mr-2" (click)="annulla()">
                {{'annulla' | translate}}
              </button>
              <button type="button" class="btn btn-primary text-white mr-2" (click)="newPassword()"
                [disabled]="formPassword.invalid">
                {{'conferma' | translate}}
                <i class="fas fa-fw fa-check"></i>
              </button>
            </div>
          </ng-template>
        </form-row>
      </form>
      <br>
    </div>
  </div>
</p-dialog>